import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/multiLocationOverviewSaga";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const FilterLevelFirstSelect = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.multiLocationOverview.availableFilters.level_1);
  const selectedOptions = useSelector((state) => state.multiLocationOverview.selectedLevelFirst);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOptions}
      placeholder="Please Select"
      enableOnly
      numberDisplayed={0}
      includeSelectAll
      onSelectChange={(data) =>
        dispatch(actionCreators.updateFiltersRequest({ name: "FilterLevelFirst", data: data }))
      }
    />
  );
};

export default FilterLevelFirstSelect;
